import { useNavigate } from "@tanstack/react-router";
import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { BlogPostCreateForm } from "@/app/Blogs/Forms/BlogPostCreateForm";
import { createBlogPostMutation } from "@/app/Blogs/GraphQL/blogPostMutations";
import { blogPostCreateValidation } from "@/app/Blogs/Validation/blogValidation";
import { BlogAudience, CreateBlogPostInput } from "@/gql/graphql";

export function BlogPostCreateDialog() {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(createBlogPostMutation);
  const navigate = useNavigate();

  return (
    <BaseDialog title="Create blog post" size="2xl">
      <GenericForm<CreateBlogPostInput>
        validationSchema={toFormikValidationSchema(blogPostCreateValidation)}
        initialValues={{
          slug: "",
          locale: "en",
          title: "",
          excerpt: null,
          blog_author_id: null,
          audience: BlogAudience.Customer,
        }}
        onSubmit={async (values) => {
          const res = await mutateAsync({ input: values });
          close();
          await navigate({
            from: "/$tenant/$orgId/supplier/{-$supplierId}",
            to: "/$tenant/$orgId/supplier/{-$supplierId}/blogs/$id",
            params: (prev) => ({ ...prev, id: res.createBlogPost.id }),
          });
        }}
      >
        <BlogPostCreateForm />
        <DialogSubmitButton text="Create post" />
      </GenericForm>
    </BaseDialog>
  );
}
